import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { TextField } from '@mui/material';
import BaseModal from 'components/BaseModal';

export const useStyles = makeStyles(() => ({
  input: {
    width: 230,
    maxWidth: '100%',
    marginTop: 6,
  },
}));

const Props = {
  open: PropTypes.bool.isRequired,
  folder: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onActionClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default function FolderModal({ open, folder, onActionClick, onClose }) {
  const classes = useStyles();
  const [name, setName] = useState('');

  useEffect(() => {
    if (folder) {
      setName(folder.name);
    } else {
      setName('');
    }
  }, [folder]);

  useEffect(() => {
    if (!open) {
      setName('');
    }
  }, [open]);

  return (
    <BaseModal
      open={open}
      title={!folder ? <b>Name your new folder</b> : <b>Rename your folder</b>}
      content={
        <TextField
          className={classes.input}
          variant="outlined"
          label="Name"
          size="small"
          value={name}
          onChange={({ target: { value } }) => setName(value.slice(0, 255))}
        />
      }
      actionText={!folder ? 'Create' : 'Update'}
      disableActionButton={name.length < 2}
      onActionClick={() => onActionClick(name)}
      onClose={onClose}
    />
  );
}

FolderModal.propTypes = Props;
